var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row trans-row",
    class: {
      last: _vm.last
    },
    on: {
      "click": _vm.onSelect
    }
  }, [_c('div', {
    staticClass: "pr0"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('img', {
    staticStyle: {
      "margin": "10px 10px 10px 0"
    },
    attrs: {
      "src": _vm.ic_bank
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_vm._v(_vm._s(_vm.item.bank_address))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.accountPretty))])])]), _vm._v(" "), _c('div', {
    staticClass: "pl0 arrow"
  }, [(_vm.showArrow) ? _c('span', {
    staticClass: "ic-arrow"
  }) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-4bdd4a84","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/TransAccountRow.vue
// module id = 235
// module chunks = 0